import { useNavigate } from "react-router-dom";
import { RouteEnum } from "../../enums/RouteEnum";
import { Breadcrumbs, Searchbar } from "@hatch-digital-nl/bravilor-storybook";
import { JSX } from "react";

interface BreadcrumbItem {
    label: string;
    link?: string;
    to?: string;
}

export const ProductRangeHeader = ({
    breadcrumbItems,
}: {
    breadcrumbItems: BreadcrumbItem[];
}): JSX.Element => {
    const navigate = useNavigate();

    return (
        <div className="p-product-range__header">
            <Breadcrumbs items={breadcrumbItems} />
            <Searchbar
                placeholderTekst="Search for machines or accessories by name or article number"
                onClick={() => navigate(RouteEnum.SEARCH)}
            />
        </div>
    );
};
